// extracted by mini-css-extract-plugin
export default {"customCardNavigation":"Custom_customCardNavigation__yE4wu","customButton":"Custom_customButton__za-Oo","customButtonIcon":"Custom_customButtonIcon__u9-Kp"};